exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n.btn-inline-center-wrapper{\r\n    display: block;\r\n    margin: 0 auto;\r\n    width: 355px;\r\n}\r\n\r\n.btn-inline-center-wrapper > button{\r\n    display: inline-block !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/payment-gateway/autorenew-confirmation/autorenew-confirmation.component.css
// module id = ../../../../../src/app/payment-gateway/autorenew-confirmation/autorenew-confirmation.component.css
// module chunks = main